import { reatomAsync, withAbort, withDataAtom } from "@reatom/async";
import { API } from "src/api";

export const getProductSampleRequest = reatomAsync(
  async (ctx, selectionId: number) => {
    return API.productSamplesApi
      .productSelectionControllerGetBySelectionId(
        { selectionId },
        {
          signal: ctx.controller.signal,
        },
      )
      .then((response) => response.data);
  },
  "getProductSampleRequest",
).pipe(withDataAtom(null), withAbort());
